import { ParamMap, Router, UrlTree } from '@angular/router';

/** Query params for catalogue browse navigation (records a view audit on item GET). */
export function catalogueDetailAuditQueryParams(): Readonly<{ auditEnabled: 'true' }> {
  return { auditEnabled: 'true' };
}

/** Whether the item GET should record a catalogue view audit event. Defaults to false. */
export function parseItemAuditEnabled(params: ParamMap): boolean;
export function parseItemAuditEnabled(
  params: Record<string, string | string[] | undefined | null>,
): boolean;
export function parseItemAuditEnabled(
  params: ParamMap | Record<string, string | string[] | undefined | null>,
): boolean {
  let raw: string | null | undefined;
  if (params && typeof (params as ParamMap).get === 'function') {
    raw = (params as ParamMap).get('auditEnabled');
  } else {
    const value = (params as Record<string, unknown>)['auditEnabled'];
    raw = Array.isArray(value) ? String(value[0]) : value != null ? String(value) : undefined;
  }
  return raw === 'true' || raw === '1';
}

export function createCatalogueAssetDetailUrlTree(
  router: Router,
  segment: 'dataset' | 'model',
  id: string,
  extraQueryParams?: Record<string, string>,
): UrlTree {
  return router.createUrlTree([`/${segment}`, id], {
    queryParams: { ...catalogueDetailAuditQueryParams(), ...extraQueryParams },
  });
}

export function navigateToCatalogueAssetDetail(
  router: Router,
  segment: 'dataset' | 'model',
  id: string,
  extraQueryParams?: Record<string, string>,
): Promise<boolean> {
  return router.navigate([`/${segment}`, id], {
    queryParams: { ...catalogueDetailAuditQueryParams(), ...extraQueryParams },
  });
}
